export const DISPUTES_TABLE_NAME = 'scorecard-disputes'
export const CALL_SEARCH_TABLE_NAME = 'call-search'
export const PLAYLISTS_TABLE_NAME = 'playlists'
